import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';

function CarouselEmbla({ items, renderItem }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, slidesToScroll: 1, align: 'start', containScroll: 'trimSnaps' });

  const scrollPrev = React.useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = React.useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {items.map((item, idx) => (
            <div className="embla__slide" key={`embla-${idx}`}>
              {renderItem(item, idx)}
            </div>
          ))}
        </div>
      </div>
      {items.length > 3 && (
        <div className="tm-carousel-nav">
          <button className="tm-carousel-btn prev" aria-label="Anterior" onClick={scrollPrev}>‹</button>
          <button className="tm-carousel-btn next" aria-label="Siguiente" onClick={scrollNext}>›</button>
        </div>
      )}
    </div>
  );
}

export default CarouselEmbla;


